export default __webpack_public_path__ + "static/media/errorIcon.c61ec2e1.svg";